import React, { Fragment, useState, useRef, useEffect, } from 'react';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { isEmpty, invoke, sortBy, last, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { useToggle, useDebounce, } from 'react-use';
import classnames from 'classnames';
import Select from 'react-select';

import firebase from '../../firebase';

const { keys, entries } = Object;
const tenantPrefixes = {
  LGP: { label: 'LGP', url: 'https://logisp-production.web.app', },
  AAA: { label: 'AAA', url: 'https://logisp3-production.web.app', },
  YPL: { label: 'YPL', url: 'https://logisp5-production.web.app', },
  TDS: { label: 'TDS', url: 'https://logisp6-production.web.app', },
  ENL: { label: 'ENL', url: 'https://logisp7-production.web.app', },
  MGP: { label: 'MGP', url: 'https://logisp8-production.web.app', },
  RMS: { label: 'RMS', url: 'https://logisp9-production.web.app', },
};

export default function LoginShopify (props) {

  return (
    <div className="login-shopify container-fluid p-5">
      <div className="d-flex flex-column align-items-center gap-3">
        <div>以下より、テナントIDの先頭3文字のものを選択してください。</div>
        <div className="d-flex gap-3">
          {
            entries(tenantPrefixes).map(([k, { label, url }]) => {
              return (
                <div key={k}>
                  <a href={url + window.location.search}>{label}</a>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};
